import { createFileRoute } from '@tanstack/react-router';

import { DealIntelligencePage } from '@/features/deal-intelligence/components/DealIntelligencePage';
import { PlatformRestriction } from '@/shared/navigation/components/PlatformRestriction';

export const Route = createFileRoute(
  '/_dashboard/deal-intelligence_/gap/$gapId'
)({
  component: GapDetailRoute,
});

function GapDetailRoute() {
  const { gapId } = Route.useParams();
  return (
    <PlatformRestriction notAllowedPlatforms={['mobile']}>
      <DealIntelligencePage gapId={gapId} />
    </PlatformRestriction>
  );
}
